<div class="footerMain fixed-bottom">
    <div class="container">
        <!--<ul>
            <li><a href="#">Important Links </a></li>
            <li><a href="#">Feedback</a></li>
            <li><a href="#">Photo Gallery </a></li>
            <li><a href="#">Contact Us </a></li>
            <li><a href="#">Terms Of Use </a></li>
        </ul>-->
        <p class="py-2" style="font-size: 13px;">Copyright &copy; {{year}} Revenue Department, Government of Maharashtra, India.</p>
        <!--<h6 class="text-center">Total Visitors : 45285</h6>-->
    </div>
</div>